/**
 * Forms
 */

if ($('.js-form').length) {

    $('.js-form').each(function () {
        $(this).validate({
            errorClass: 'js-form-error',
            validClass: 'js-form-valid',
            errorPlacement: function (error, element) {
                if (element.attr('type') == 'radio' || element.attr('type') == 'checkbox') {
                    let errorContainer = element.closest('.c-form-checkboxes').find('.c-form-checkboxes__error');
                    error.appendTo(errorContainer);
                } else {
                    error.insertAfter(element);
                }
            },
            submitHandler: function (form) {
                $('.js-submit-button').prop('disabled', true);
                $(form).addClass('js-form--loading');
                form.submit();
            }
        });
    });

    $.validator.methods.email = function (value, element) {
        return this.optional(element) || /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b$/i.test(value);
    }
    
    if ($('.js-only-phone').length) {
        $('.js-only-phone').each(function (index, value) {
            $(this).rules('add', {
                minlength: 12,
                maxlength: 12,
                messages: {
                    required: 'Enter a phone number',
                    minlength: 'You must enter 10 digits',
                    maxlength: 'You must enter 10 digits',
                }
            });
        })
    }

    if ($('.js-zipcode').length) {
        $('.js-zipcode').each(function (index, value) {
            $(this).rules('add', {
                digits: true,
                minlength: 3,
                maxlength: 5,
                remote: {
                    url: 'https://www.confiejarvis.com/thor/javascript?',
                    data: {
                        zipcode: function () {
                            return $(value).val();
                        }
                    },
                    dataFilter: function (data) {
                        if (data === "1") {
                            return '"true"';
                        }
                        return '"Enter a valid zip code"';
                    }
                },
                messages: {
                    required: 'Enter your zip code'
                }
            });
        })
    }
}

/* const checkAddress = document.getElementById('cbMailAddress');
const propertyAddress = document.getElementById('street');
const propertyCity = document.getElementById('txtLeadPropCity');
const propertyState = document.getElementById('txtLeadPropState');
const propertyZipcode = document.getElementById('zipcode');
const mailingAddress = document.getElementById('txtLeadMailAddress');
const mailingCity = document.getElementById('txtLeadMailCity');
const mailingState = document.getElementById('txtLeadMailState');
const mailingZipcode = document.getElementById('txtLeadMailZip');

const checked = () => {
    if (checkAddress.checked) {
        console.log('checked');
        mailingAddress.value = propertyAddress.value;
        mailingCity.value = propertyCity.value;
        mailingState.value = propertyState.value;
        mailingZipcode.value = propertyZipcode.value;
    } else {
        console.log('clear');
        mailingAddress.value = '';
        mailingCity.value = '';
        mailingState.value = '';
        mailingZipcode.value = '';
    }
}

checkAddress.addEventListener('click', checked); */